import { SessionAPI } from './api/index.js';

export const session = SessionAPI.getInstance();
